// ALTERAR ABAIXO COM O NOME DO CLIENTE O CLIENTID DA INSPEÇÃO OFFLINE
export const REACT_APP_CLIENT_NAME = 'LD';
export const REACT_APP_CLIENT_ID = '7c0b57c6-4df6-48a8-be00-fee7424a91d2';

//NAO ALTERAR CODIGO ABAIXO:
//export const API_BACKEND = 'http://localhost:3010';
export const API_BACKEND = 'https://lite.efw-alphamanager.com/api';
export const REACT_APP_API_BACKEND = 'https://efw-alphamanager.com/api';
export const REACT_APP_SCANNER_OFFLINE = false;
export const REACT_APP_KEYCLOAK_JSON = {
    "realm": "Alpha Manager",
    "auth-server-url": "https://efw-alphamanager.com/auth/",
    //"auth-server-url": "http://177.54.58.123:8080/auth/",
    "ssl-required": "none",
    "resource": "react",
    "public-client": true,
    "confidential-port": 0
}